import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuidanseType } from './guildance.type';
import { ComponentColors, PcIcon } from '@pc/common';

@Component({
  selector: 'pc-alert-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-card.component.html',
  styleUrl: './alert-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertCardComponent {
  public color = input<ComponentColors>('primary');
  public title = input<string>('title');
  public guidance = input<string>('guidance');
  public type = input<GuidanseType>('top');
  public showIcon = input<boolean>(true);
  public pcIcon = PcIcon;
}
